<div *ngIf="credits" class="row">
  <div class="s12">
    <h5>{{ 'clients.credits.resume' | translate }}</h5>
    <div class="row">
      <div class="col s12 margin-top" *ngIf="available && tooltipsText">
        <div class="flex-start">
          <div class="block-charts charts-canvas normal">
            <lms-chart
              [charType]="'doughnut'"
              [labels]="chartLabels"
              [data]="chartData"
              [colors]="chartColors"
              [legend]="false"
              [options]="chartOptions"
            >
            </lms-chart>
            <div class="chart-subtitle">{{ credits?.total }} {{ 'dashboard.credits.credits' | translate }}</div>
          </div>
          <ul class="chart-list-colors">
            <li *ngFor="let label of chartLabels; let i = index">
              <span class="color" [ngClass]="chartLegendColorClasses[i]"></span>
              <span class="label"
                >{{ label }}: {{ chartData[i] }} - {{ (chartData[i] / credits.total) * 100 | number : '1.2-2' }}%</span
              >
              <gl-tooltip class="gap-left" posBottom [text]="tooltipsText[chartKeys[i]]"></gl-tooltip>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="data">
      <div *ngIf="allCreditsExpired">
        {{ 'clients.credits.creditsExpired' | translate }}
      </div>
      <div *ngIf="noCreditsBags">{{ 'clients.credits.noCreditsBags' | translate }}</div>
      <div *ngIf="allCreditsConsumed">{{ 'clients.credits.allCreditsConsumed' | translate }}</div>
    </div>
  </div>
</div>
